// Mail « Les sorties autour de toi » (docs/events-digest-email-spec.md) :
// consentement explicite et clic depuis l'e-mail.
import { requestKarangoApi } from "../../core/api/karangoTransport";

// Libelle affiche au moment du choix ; la version est enregistree comme
// preuve cote serveur (spec §10.2). Changer le texte = nouvelle version.
export const EVENTS_DIGEST_TEXT_VERSION = "2026-10-v2";
export const EVENTS_DIGEST_CONSENT_TEXT = "Reçois le dimanche et le mercredi par e-mail les sorties près de chez toi.";

const CLICK_FRAGMENT_KEY = "dg";
const CLICK_TOKEN_PATTERN = /^[A-Za-z0-9_-]{22}$/;

// Meme regle que le serveur : accord ET preference e-mail.
export function isEventsDigestConsentActive(settings) {
  const consent = settings?.notificationConsents?.eventsDigest;
  const pref = settings?.notifications?.eventsDigest;
  const emailPref = pref && typeof pref === "object" ? pref.email : pref;
  return consent?.granted === true && emailPref === true;
}

export async function setEventsDigestConsent({ intent, source }) {
  const payload = await requestKarangoApi("/v1/me/consents/events-digest", {
    method: "POST",
    requiresAuth: true,
    body: { intent, source, textVersion: EVENTS_DIGEST_TEXT_VERSION },
  });
  return payload?.consent || null;
}

// Lit le jeton de clic dans le fragment (#dg=…), l'efface aussitot de l'URL
// et renvoie le jeton. Le fragment n'est jamais envoye au serveur avec la
// page : le jeton n'apparait dans aucune URL ni journal HTTP (spec §12.2).
export function takeEventsDigestClickToken(location = window.location, history = window.history) {
  const hash = String(location?.hash || "");
  if (!hash.includes(`${CLICK_FRAGMENT_KEY}=`)) return null;
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const token = params.get(CLICK_FRAGMENT_KEY);
  params.delete(CLICK_FRAGMENT_KEY);
  const rest = params.toString();
  try {
    history?.replaceState?.(history.state, "", `${location.pathname}${location.search}${rest ? `#${rest}` : ""}`);
  } catch (_error) {
    // URL non modifiable (contexte restreint) : sans incidence.
  }
  return token && CLICK_TOKEN_PATTERN.test(token) ? token : null;
}

// Au demarrage : un seul envoi, sans attendre ni bloquer l'appli. Le corps
// porte le jeton ; la reponse (toujours 204) ne revele rien.
export function captureEventsDigestClick({ location = window.location, history = window.history, request = requestKarangoApi } = {}) {
  const token = takeEventsDigestClickToken(location, history);
  if (!token) return false;
  Promise.resolve()
    .then(() => request("/v1/events-digest/clicks", { method: "POST", body: { token }, retryable: false }))
    .catch(() => null);
  return true;
}
